import { installRecordSync } from "./utils/installRecordSync";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme";
import "./index.css";
import "./styles/popups.css";
import { installApiFetchRetry } from "./utils/installApiFetchRetry";

installApiFetchRetry();
installRecordSync();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>
);
